module.exports = __webpack_public_path__ + "static/hero-76039ea9958fa85c3ef7ce5cdea11904.svg";